import { createAction } from '@wix/communities-blog-client-common';
import { type CommonThunkAction } from '@app/types/common-thunk-action.type';
import { appendAuthHeaders, getBlogApiBaseUrl } from '../../controller/helpers';

export const FETCH_WRITERS_SUCCESS = 'writers/FETCH_SUCCESS';

const fetchWritersRequest = createAction('writers/FETCH_REQUEST');
const fetchWritersSuccess = createAction(FETCH_WRITERS_SUCCESS);
const fetchWritersFailure = createAction('writers/FETCH_FAILURE');

export const fetchWriters =
  (): CommonThunkAction<any> =>
  (dispatch, _getState, { httpClient, errorHandler, platformApi }) => {
    dispatch(fetchWritersRequest());
    const { withErrorHandler } = errorHandler;

    return withErrorHandler(
      () =>
        httpClient.get(`${getBlogApiBaseUrl(platformApi)}/_api/users?roles=admin,writer,editor`, {
          headers: appendAuthHeaders(platformApi),
        }),
      { errorCodesMap: {} },
    )
      .then((response) => dispatch(fetchWritersSuccess(response.data)))
      .catch(() => dispatch(fetchWritersFailure()));
  };
